// src/ui/AddToListModal.jsx — put this chat into one of my lists.
//
// Opened from Chat info. Every list I own is shown with a live tick for whether
// this chat is already in it, and clicking toggles membership right away — the
// same users/{uid}/chatLists writes the sidebar makes, so the phone follows.
//
// "New list" hands off to the full editor with this chat already seeded, which
// is where naming it and adding more people (recent chats, or anyone found by
// name / username / phone / email) happens — one place for that, rather than a
// second half-copy of the same picker.

import React, { useEffect, useState } from 'react';
import { X, Check, Plus } from './icons';
import ListEditorModal from './ListEditorModal';
import { watchChatLists, addToList, removeFromList } from '../services/chatLists';

export default function AddToListModal({ myUid, chats, chatId, chatTitle, onClose }) {
  const [lists, setLists] = useState([]);
  const [busy, setBusy] = useState('');
  const [makeNew, setMakeNew] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => watchChatLists(myUid, setLists), [myUid]);

  const toggle = async (l) => {
    const inIt = (l.chatIds || []).includes(chatId);
    setBusy(l.id); setErr('');
    try {
      if (inIt) await removeFromList(myUid, l.id, chatId, l.chatIds || []);
      else await addToList(myUid, l.id, chatId);
    } catch { setErr('That didn’t save — try again.'); }
    setBusy('');
  };

  if (makeNew) {
    return (
      <ListEditorModal
        myUid={myUid}
        chats={chats}
        list={null}
        initialIds={[chatId]}
        onClose={() => { setMakeNew(false); onClose(); }}
        onCreated={() => {}}
      />
    );
  }

  return (
    <div className="ng-modal" onClick={onClose}>
      <div className="ng-card atl-card" onClick={(e) => e.stopPropagation()}>
        <div className="ng-head">
          <b>Add to a list</b>
          <button className="icon-btn" onClick={onClose} aria-label="Close"><X /></button>
        </div>

        <div className="ng-body">
          <div className="atl-sub">Choose where {chatTitle} should appear in your chat list.</div>

          <div className="ng-results">
            {lists.length === 0 && (
              <div className="ci-empty">You have no lists yet — make the first one below.</div>
            )}
            {lists.map((l) => {
              const inIt = (l.chatIds || []).includes(chatId);
              return (
                <button
                  className={`ng-row ${inIt ? 'on' : ''}`} key={l.id}
                  disabled={busy === l.id} onClick={() => toggle(l)}
                >
                  <span className="atl-dot">{l.name.trim().charAt(0).toUpperCase()}</span>
                  <span className="ng-row-who">
                    <b>{l.name}</b>
                    <i>{(l.chatIds || []).length} {(l.chatIds || []).length === 1 ? 'chat' : 'chats'}</i>
                  </span>
                  {inIt && <Check width={15} height={15} />}
                </button>
              );
            })}
          </div>

          <button className="atl-new" onClick={() => setMakeNew(true)}>
            <Plus width={15} height={15} /> New list with {chatTitle}
          </button>

          {err && <div className="pm-err">{err}</div>}
        </div>

        <div className="ng-foot">
          <span className="ng-count">Synced with your phone</span>
          <button className="lg-go slim" onClick={onClose}>Done</button>
        </div>
      </div>
    </div>
  );
}
